import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ArrowUpIcon from "assets/icons/ArrowUpIcon.png";
import ArrowDownIcon from "assets/icons/ArrowDownIcon.png";

const FAQ = () => {
  const { t } = useTranslation();

  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Who is eligible to participate in the Awards?",
      answer: (
        <div>
          <div>
            Participation is open to <b>for-profit companies</b> only.
            Non-profit organizations are <b>not eligible.</b> Eligible
            participants include:
          </div>
          <div className="">
            <ul className="pt-1 pl-5 space-y-1 list-disc">
              <li>
                Both <b>KADIN members and non-members</b>
              </li>
              <li>
                <b>State-Owned Enterprises (SOEs/BUMN)</b> and <b>non-SOEs</b>
              </li>
              <li>
                <b>Publicly listed</b> and <b>non-listed companies</b>
              </li>
              <li>
                Companies with <b>more than 100 full-time employees</b>
              </li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      question: "Is there a fee to join the Awards?",
      answer: (
        <div>
          <div>
            Yes. Each company is required to pay a registration fee of IDR
            20,000,000, which includes:
          </div>
          <div>
            <ul className="pt-1 pl-5 space-y-1 list-disc">
              <li>
                Application for two award categories (Governance of ESG and ESG
                Project Management – one project). Additional projects are
                subject to a fee of IDR 10,000,000 per project.
              </li>
              <li>
                Access to a 3-hour ESG workshop for one (1) participant.
                Additional participants may join at IDR 2,000,000 per person.
              </li>
              <li>
                One (1) invitation to the Gala Dinner & Awarding Night (for
                nominated companies only). Additional invitations are available
                at IDR 3,500,000 per person.
              </li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      question:
        "Is there a fee to attend the Awarding Night on June 18, 2026?",
      answer: (
        <div>
          Each nominated participant is entitled to one (1) complimentary seat
          at the Awarding Night. Additional invitations are available at IDR
          3,500,000 per person.
        </div>
      ),
    },
    {
      question: "How can I provide supporting evidence?",
      answer: (
        <div>
          <b>
            Please provide a shareable Google Drive link in the RFI (submission
            form). Upload all supporting materials (such as documents, photos,
            reports, and other relevant files) to your own Google Drive folder
            and ensure access is enabled.
          </b>
        </div>
      ),
    },
    {
      question: "Can I submit more than one ESG initiative?",
      answer: (
        <div>
          <div>
            <b>Yes</b>. Companies may submit more than one ESG project. An
            additional fee of IDR 10,000,000 applies for each additional
            project. For example, submitting two additional projects will incur
            an additional fee of IDR 20,000,000.
          </div>
          <div className="pt-2">
            The additional fee includes:
            <ul className="pl-5 space-y-1 list-decimal">
              <li>
                Submission of one (1) additional ESG project for award
                consideration;
              </li>
              <li>
                Access to a 3-hour offline workshop on Excellent ESG Governance
                and Project Management (scheduled for May 2026); and
              </li>
              <li>
                One (1) complimentary seat for a company representative at the
                Awarding Night, should the project be shortlisted as a nominee.
              </li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      question: "Can I submit only one ESG initiative?",
      answer: (
        <div>
          <b>Yes</b>, you may choose to submit <b>just one</b> ESG initiative
          project.
        </div>
      ),
    },
    {
      question:
        "Can I choose to submit only the Project Management of ESG Initiative Award and not the Governance of ESG Award?",
      answer: (
        <div>
          <div>
            <b>No</b>, participation in the Award{" "}
            <b>requires submission for both categories</b>:
          </div>
          <div>
            <ul className="pt-1 pl-5 space-y-1 list-disc">
              <li>
                <b>Governance of ESG Award</b>
              </li>
              <li>
                <b>1 (One) Project Management of ESG Initiative Award</b>
              </li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      question: "How do I know the total fee I need to pay when registering?",
      answer: (
        <div>
          <div>
            You can find the applicable registration fees on the information
            provided on this landing page or by referring to the Registration
            Guide.
          </div>
          <div className="pt-2">
            If you still have any questions or need further clarification,
            please feel free to contact us through the Contact Us section.
          </div>
        </div>
      ),
    },
    {
      question:
        "Why haven’t I received a payment confirmation after completing the registration fee transfer?",
      answer: (
        <div>
          <div>
            Don’t worry. After we receive your payment, our team will verify and
            reconcile the transaction with our records at the end of each
            business day.
          </div>
          <div className="pt-2">
            Payment confirmation will be sent to you on the following day once
            the verification process is completed.
          </div>
        </div>
      ),
    },
    {
      question: "What is included in the First Assessment Stage?",
      answer: (
        <div>
          The first assessment is based on the <b>completion and quality</b>, of
          the submitted <b> RFI (Request for Information)</b>.{" "}
          <b>
            The more complete and accurate the submission, the higher the score
          </b>
          .
        </div>
      ),
    },
    {
      question: "What is included in the Second Assessment Stage?",
      answer: (
        <div>
          Companies that pass the first stage will proceed to an{" "}
          <b>online interview</b> with the <b>Judging Panel</b> for further
          evaluation.
        </div>
      ),
    },
    {
      question:
        "What happens if a participant does not pass the First or Second Assessment?",
      answer: (
        <div>
          <div>
            Participants who do not pass the First Assessment or Second
            Assessment will still receive a Guaranteed CCS Session (Combined
            Clinic for Sustainability) as part of the program benefits.
          </div>
          <div className="pt-2">
            This includes:
            <ul className="pt-1 pl-5 space-y-1 list-disc">
              <li>
                A free online consultation on ESG, Sustainability, or CSR topics
                with Institute for Sustainability and Agility (ISA) Expert
              </li>
              <li>Up to 60 minutes per session</li>
              <li>
                An ESG Governance Commitment or ESG Project Management
                Commitment Certificate
              </li>
            </ul>
          </div>
        </div>
      ),
    },
    {
      question:
        "If a company is nominated and invited to the Awarding Night, is it possible to send more than one representative?",
      answer: (
        <div>
          <b>Yes</b>. Each nominated company is provided with one (1)
          complimentary seat at the Awarding Night. Attendance by additional
          representatives is subject to an additional fee of IDR 3,500,000 per
          person.
        </div>
      ),
    },
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div id="faqContainer">
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl app-animation-translate-start section-title">
            {t("FAQBannerText")}
          </p>
          <div className="flex justify-center">
            <div className="w-full max-w-3xl space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="overflow-hidden border-none rounded-lg shadow-sm"
                >
                  {/* Header */}
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full flex justify-between items-center bg-[#E78D41] text-white font-semibold text-left px-6 py-4 rounded-lg focus:outline-none transition"
                  >
                    <span>{faq.question}</span>
                    {openIndex === index ? (
                      <img
                        src={ArrowUpIcon}
                        alt="Arrow down icon"
                        className="w-5 h-auto"
                      />
                    ) : (
                      <img
                        src={ArrowDownIcon}
                        alt="Arrow down icon"
                        className="w-5 h-auto"
                      />
                    )}
                  </button>

                  {/* Answer */}
                  {openIndex === index && (
                    <div className="px-8 py-4 text-sm leading-relaxed text-gray-800 bg-white">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
